<template>
    <div class="socialevents">
        <div class="destination-container">
            <div class="destination-writeups">
                <p v-html="aboutList.content">
                </p>
            </div>
            <div class="card-container">
                <div class="card">
                    <Trophy style="color: #094923;" />
                    <h2>{{ aboutList.coach }}</h2>
                    <h3>Elite Coaches & Staff</h3>
                    <p>Certified Professionals dedicated to your success</p>
                </div>
                <div class="card">
                    <Users style="color: #094923;" />
                    <h2>{{ aboutList.members }}</h2>
                    <h3>Members</h3>
                    <p>Across the Globe</p>
                </div>
                <div class="card">
                    <Star style="color: #094923;" />
                    <h2>{{ aboutList.excellence }}</h2>
                    <h3>Excellence</h3>
                    <p>The LLTC 1895 Standard</p>
                </div>
                <div class="card">
                    <CalendarDays style="color: #094923;" />
                    <h2>{{ aboutList.alumni }}</h2>
                    <h3>Tennis Stalwart</h3>
                    <p>Tennis Stalwarts we trust</p>
                </div>
            </div>
        </div>
    </div>
</template>

<script setup>
import {
    Trophy, Users,
    Star,
    CalendarDays
} from 'lucide-vue-next';

import { ref, onMounted, onBeforeUnmount } from "vue";
import axios from 'axios';

const aboutList = ref([]);

//let base_url = process.env.VUE_APP_BASE_LIVE_URL

onMounted( async () => {
  await listRecords();
});

onBeforeUnmount( async () => {
  
});



// Action methods

const listRecords = async () => {
  try {
    const response = await axios.get('/about_list.php', { });
    if (response.data.status) aboutList.value = response.data.data[0];
    else console.error(response.data.message);
  } catch (error) {
    console.error(error.message);
  }
};

</script>

<style scoped lang="scss">
.socialevents {
    max-width: 96%;
    margin: auto;
    margin-top: 5rem;
}

.destination-container {
    display: flex;
    justify-content: space-between;
    align-items: start;
    margin: 2rem;
    

    .destination-writeups {
        width: 80%;

        h2 {
            max-width: 401px;
            margin-bottom: 2rem;
            text-align: left;
            font-size: 48px;
            font-weight: 400;
            font-family: "Open Runde", sans-serif;
        }

        p {
            max-width: 501px;
            text-align: left;
            font-size: 20px;
            font-weight: 400;
            font-family: "Open Runde", sans-serif;
        }

        ul {
            list-style: none;
            padding: 0;
            margin-top: 4rem;

            li {
                display: flex;
                align-items: start;
                justify-content: start;
                gap: 10px;
                margin-bottom: 1rem;
                // background-color: aqua;

                div {
                    width: 12px;
                    height: 12px;
                    border-radius: 50%;
                    margin-top: 8px;
                    background-color: #ED4E24;
                }

                p {
                    margin-left: 10px;
                    font-size: 20px;
                    margin: 0%;
                    padding: 0%;
                    font-weight: 400;
                    font-family: "Open Runde", sans-serif;
                }
            }
        }
    }

    .card-container {
        display: grid;
        grid-template-columns: repeat(2, 1fr);
        gap: 20px;

        .card {
            width: 244px;
            height: 248px;
            border: 1px solid #00000033;
            box-shadow: 0 4px 8px rgba(0, 0, 0, 0.1);
            border-radius: 20px;
            display: flex;
            justify-content: center;
            align-items: center;
            flex-direction: column;
            padding: 10px;

            h2 {
                font-size: 28px;
                font-weight: 700;
                margin: 10px 0;
                font-family: "Open Runde", sans-serif;
                text-align: center;
            }

            h3 {
                font-size: 15px;
                font-weight: 600;
                margin: 10px 0;
                font-family: "Open Runde", sans-serif;
                text-align: center;
            }

            p {
                font-size: 16px;
                font-weight: 400;
                font-family: "Open Runde", sans-serif;
                text-align: center;
                color: #555555;
            }
        }
    }
}

@media (max-width: 768px) {
    .socialevents {
        max-width: 100%;
        margin: auto;
        margin-top: 2rem;
    }

    .destination-container {
        display: flex;
        flex-direction: column;
        align-items: start;

        .destination-writeups {
            width: 100%;
        }

        .card-container {
            display: grid;
            grid-template-columns: repeat(1, 1fr);
            gap: 20px;
            width: 100%;

            .card {
                width: 100%;
                height: 248px;
                border: 1px solid #00000033;
                box-shadow: 0 4px 8px rgba(0, 0, 0, 0.1);
                border-radius: 20px;
                display: flex;
                justify-content: center;
                align-items: center;
                flex-direction: column;
                padding: 0px;
            }
        }
    }
}
</style>
